import React from 'react';
import { CollapsibleList } from './CollapsibleList';
export var PropertyTypes = function PropertyTypes(_ref) {
  var domain = _ref.domain,
    geoPathUri = _ref.geoPathUri;
  var path;
  if (/\d+/.test(geoPathUri)) {
    path = "".concat(domain, "/Suche/de");
  } else {
    path = "".concat(domain, "/Suche").concat(geoPathUri);
  }
  var propertyTypes = [{
    name: 'Immobilien',
    link: "".concat(path, "/immobilien")
  }, {
    name: 'Wohnungen',
    link: "".concat(path, "/haeuser")
  }, {
    name: 'Wohnung mieten',
    link: "".concat(path, "/wohnungen")
  }, {
    name: 'Wohnung kaufen',
    link: "".concat(path, "/haus-kaufen")
  }, {
    name: 'Häuser',
    link: "".concat(path, "/haus-mieten")
  }, {
    name: 'Haus kaufen',
    link: "".concat(path, "/wohnung-kaufen")
  }, {
    name: 'Haus mieten',
    link: "".concat(path, "/wohnung-mieten")
  }, {
    name: 'Grundstücke',
    link: "".concat(path, "/grundstuecke")
  }, {
    name: 'Grundstück kaufen',
    link: "".concat(path, "/grundstueck-kaufen")
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-item desk-one-third lap-one-half palm-one-whole padding-bottom-xl"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-body-medium-bold margin-bottom-xs",
    "data-testid": "property-search"
  }, "Immobiliensuche"), /*#__PURE__*/React.createElement(CollapsibleList, {
    items: propertyTypes
  }));
};